<script setup>
import { useTranslation } from '../../composables/useTranslation';

const { t } = useTranslation();
</script>

<template>
  <div class="bg-white">
    <!-- Header Section with Purple Background -->
    <div class="bg-gradient-to-r from-purple-200 to-purple-300 px-8 py-6 text-center">
      <div class="flex items-center justify-center gap-3">
        <!-- FluentCRM Logo -->
        <div class="rounded-full p-2">
          <img :src="Image('integrations/fluent-crm.png')" class="w-8 h-auto" alt="FluentCRM">
        </div>
        <h1 class="text-3xl text-purple-500 italic font-light">
          fluent<span class="text-purple-900 not-italic font-semibold">CRM</span>
        </h1>
      </div>
    </div>

    <!-- Content Section -->
    <div class="px-8 py-8">
      <!-- Description -->
      <p class="text-gray-600 mb-8 leading-relaxed text-sm">
        {{ t('fluentcrm_description') }}
      </p>

      <!-- Instructions -->
      <div class="mb-8">
        <h2 class="font-semibold text-gray-800 mb-4 text-base">{{ t('instructions') }}</h2>
        
        <ol class="list-decimal list-inside space-y-3 text-sm text-gray-600">
          <li class="leading-relaxed">{{ t('fluentcrm_step1') }}</li>
          <li class="leading-relaxed" v-html="t('fluentcrm_step2', { step: `<span class='font-semibold text-gray-800'>${t('tab_triggers')}</span>` })"></li>
          <li class="leading-relaxed" v-html="t('fluentcrm_step3', { 
              option: `<span class='font-semibold text-gray-800'>${t('send_leads_to_fluentcrm')}</span>`,
              action: `<span class='font-semibold text-gray-800'>${t('activate')}</span>`
          })"></li>
          <li class="leading-relaxed">{{ t('fluentcrm_step4') }}</li>
        </ol>
      </div>

      <!-- Success Message -->
      <div class="mb-8">
        <p class="text-gray-600 text-sm">
          {{ t('fluentcrm_success') }}
        </p>
      </div>

      <!-- Watch Tutorial Button -->
      <div class="text-center flex items-center justify-center">
        <a href="https://www.youtube.com/watch?v=5VFeUIqw3cg" target="_blank" class="bg-gray-100 hover:bg-transparent transition duration-150 rounded-full cursor-pointer px-3 py-1.5 border border-gray-100 inline-flex items-center justify-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
<path fill="#FF3D00" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"></path><path fill="#FFF" d="M20 31L20 17 32 24z"></path>
</svg>
               {{ t('watch_tutorial') }}
            </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Additional custom styles if needed */
</style>